import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_URL } from "../../config";

export const reviewsApi = createApi({
  reducerPath: "reviewsApi",
  tagTypes: ["Reviews"],
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) headers.set("authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    addReviews: builder.mutation({
      query: (payload) => ({
        url: "/reviews/portal/add",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Reviews"],
    }),
    getRecentReviews: builder.query({
      query: ({ location, limit = 50 } = {}) => {
        const params = new URLSearchParams();
        if (location) params.append("location", location);
        if (limit) params.append("limit", String(limit));
        const qs = params.toString();
        return `/reviews/portal/recent${qs ? `?${qs}` : ""}`;
      },
      providesTags: ["Reviews"],
    }),
  }),
});

export const { useAddReviewsMutation, useGetRecentReviewsQuery } = reviewsApi;
